import { RefinementList } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';

import { useSearchDictionary } from '../util';

const AuthorFacet = () => {
  const dict = useSearchDictionary();

  return (
    <div className={classnames('mb-4')}>
      <div className={classnames('text-blue-navy', 'heading-sm', 'mb-6')}>{dict.author}</div>
      <RefinementList attribute="author" limit={10} sortBy={['name:asc']} showMore />
    </div>
  );
};

export default AuthorFacet;
